import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'
import { QuestionTransitions } from '../../../style/transitions'
import Text from '../../common/Text'
import { ALDINE } from '../../../constants/type'

const QuestionLabel = forwardRef(
  ({ text, questionId, responseText, caption, showCaption, isBold }, ref) => {
    return (
      <QuestionContainer
        ref={ref}
        key={`q_${questionId}`}
        initial={QuestionTransitions.initial}
        animate={QuestionTransitions.animate}
        exit={QuestionTransitions.exit}
        transition={QuestionTransitions.transition(0.5, 0.6)}
      >
        {showCaption && (
          <QuestionNumber>
            <Number>{caption || `Question ${questionId}`}</Number>
          </QuestionNumber>
        )}
        <QuestionText big={isBold}>
          <Text.h2
            uppercase={isBold}
            weight={isBold ? 700 : 400}
            lineHeight={1.2}
            margin="1em 0"
          >
            {text}
          </Text.h2>
        </QuestionText>
        <Empty />
      </QuestionContainer>
    )
  },
)

QuestionLabel.propTypes = {
  showCaption: PropTypes.bool,
  caption: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  questionId: PropTypes.number.isRequired,
  responseText: PropTypes.string,
  isBold: PropTypes.bool,
}
QuestionLabel.defaultProps = {
  showCaption: true,
}

export default QuestionLabel

const Empty = styled.div`
  ${({ theme }) => css`
    width: 46px;
    ${theme.media.md`
      width: auto;
    `}
  `}
`
const Number = styled.div(
  ({ theme }) => css`
    text-align: center;
    margin: 0 auto;
    font-size: 0.875em;
    padding-top: 0.7em;
    ${theme.media.lg`
      font-size: 1.25em;
      padding-top: 1em;
    `}
  `,
)
const QuestionText = styled.div`
  ${({ theme, big }) => css`
    text-align: center;
    color: #454153;

    h2 {
      margin-top: auto;
      line-height: 110%;
      padding: 0.15em 1em 0.5em;
      top: auto;
      transform: none;
      font-size: 1.1875em;

      ${big &&
        css`
          font-size: 1.875em;
          margin-bottom: 0.5em;
        `}

      ${theme.media.lg`
        padding: 0.15em 1em 0.35em;
        font-size: 2.4em;
        margin-bottom: 0.7em;
      `}
    }
  `}
`
const QuestionContainer = styled(motion.div)`
  ${({ theme }) => css`
    font-family: ${ALDINE};
    background-color: white;

    ${theme.media.md`
    `}
  `}
`

const QuestionNumber = styled.div`
  ${() => css`
    margin: 0 auto;
    position: relative;
  `}
`
